export default {
    methods: {
        nationalCodeValidation(value) {
            let validate = false;
            if (
                value == '1111111111' ||
                value == '0000000000' ||
                value == '2222222222' ||
                value == '3333333333' ||
                value == '4444444444' ||
                value == '5555555555' ||
                value == '6666666666' ||
                value == '7777777777' ||
                value == '8888888888' ||
                value == '9999999999') {
                return validate;
            }
            if (value && value.length == 10) {
                const nationalCode = value.split("");
                let num = nationalCode.map((n, index) => {
                    if (10 - index > 1) return n * (10 - index);
                    return 0;
                });
                const reducer = (accumulator, currentValue) =>
                    accumulator + currentValue;
                let res = Math.floor(num.reduce(reducer) % 11);
                if (res >= 2) {
                    11 - res == parseInt(nationalCode[9])
                        ? (validate = true)
                        : (validate = false);
                } else {
                    res == parseInt(nationalCode[9])
                        ? (validate = true)
                        : (validate = false);
                }
            }
            return validate;
        }
    }
}
